<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 搜索栏 -->
      <div class="content_title data_screen">
        <div class="data_screen_line">
          <span class="title" slot="reference" @click="clickCancel">学院管理 > 课程列表 > {{ title }}</span>
          <span>
            <el-input
              v-model="search.content"
              placeholder="课程名称"
              style="width: 300px"
              size="small"
              suffix-icon="el-icon-search"
              @change="pageChange(1)"
              clearable
            />
          </span>
          <span class="data_screen_tab">
            <!-- 分类  -->
            <el-select
              v-model="search.disabledStatus"
              clearable
              placeholder="请选择-状态"
              size="small"
              style="width: 150px"
              @change="pageChange(1)"
            >
              <el-option label="全部状态" value />
              <el-option label="启用" value="1" />
              <el-option label="禁用" value="0" />
            </el-select>
          </span>
          <span class="data_screen_tab">
            <!-- 分类  -->
            <el-select
              v-model="search.type"
              clearable
              placeholder="请选择-类型"
              size="small"
              style="width: 150px"
              @change="pageChange(1)"
            >
              <el-option label="全部类型" value />
              <el-option label="公众号文章" value="1" />
              <el-option label="视频教程" value="2" />
            </el-select>
          </span>
          <el-button
            class="btn search_btn"
            size="small"
            @click="pageChange(1)"
            >查询</el-button>
        </div>
        <el-button
          type="primary"
          class="btn_add btn"
          size="small"
          @click="clickAdd"
          >添加课程</el-button
        >
      </div>
      <!-- 具体内容 -->
      <div class="content_auto">
        <div class="content table_data table_data_left">
          <!-- 表格 -->
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="sortNo" label="排序编号" align="center"></el-table-column>
            <el-table-column prop="coverImage" label="封面图片" align="center">
              <template slot-scope="scope">
                <el-image
                  class="tableImage"
                  :src="scope.row.coverImageTemp"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="课程名称"
              align="center"
            ></el-table-column>
            <el-table-column prop="type" label="课程类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">公众号文章</span>
                <span v-if="scope.row.type == 2">视频教程</span>
              </template>
            </el-table-column>
            
            <el-table-column
              prop="disabledStatus"
              label="课程状态"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.disabledStatus == 1">启用</span>
                <span v-if="scope.row.disabledStatus != 1" style="color: red"
                  >禁用</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              label="更新时间"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.disabledStatus != 1"
                  style="color: #00cb9f"
                  @click="clickStatus(scope.row)"
                  >启用</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.disabledStatus == 1"
                  style="color: red"
                  @click="clickStatus(scope.row)"
                  >禁用</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: #00cb9f"
                  @click="clickUpdate(scope.row)"
                  >编辑</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: red"
                  @click="clickDelete(scope.row)"
                  >删除</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: #00cb9f"
                  @click="clickInfo(scope.row)"
                  >详情</el-button
                >&nbsp;
              </template>
            </el-table-column>
          </el-table>
          <!-- 表格结束 -->
          <!-- 分页 -->
          <div class="page">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="page.total"
              :page-size="page.size"
              @current-change="pageChange"
            ></el-pagination>
          </div>
        </div>
      </div>

      <!-- 添加成员弹出框 -->
      <el-dialog
        :title="dialogType == 1 ? '添加课程' : dialogType == 2 ? '编辑课程':'课程详情'"
        :rules="rules"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="560px"
      >
        <div class="dialog_context">
          <el-form :model="form" :rules="rules" ref="addForm">
            <el-form-item
              label="课程封面"
              :label-width="dialogWidth"
              prop="name"
            >
              <el-upload
                class="avatar-uploader"
                :action="baseURL+'/api/common/file/upload/image'"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                accept=".jpg,.jpeg,.png,.gif"
                :disabled="dialogType == 3"
              >
                <img v-if="form.coverImageTemp" :src="form.coverImageTemp" class="avatar" />
                <i v-else-if="uploadFileImage == 0" class="el-icon-plus avatar-uploader-icon"></i>
                <i v-else class="el-icon-loading avatar-uploader-icon-loading"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="课程名称"
              :label-width="dialogWidth"
              prop="name"
            >
              <el-input v-model="form.name" autocomplete="off" :disabled="dialogType == 3"></el-input>
            </el-form-item>
            <el-form-item
              label="课程排序"
              :label-width="dialogWidth"
              prop="sortNo"
            >
              <!-- <el-input v-model="form.sortNo" autocomplete="off"></el-input> -->
              <el-input-number v-model="form.sortNo" :min="1" :precision="0" label="课程排序" :disabled="dialogType == 3"></el-input-number>
            </el-form-item>
            <el-form-item
              label="课程类型"
              :label-width="dialogWidth"
              prop="type" :disabled="dialogType == 3"
            >
              <el-select
                v-model="form.type"
                placeholder="请选择"
                style="width: 100%"
                :disabled="dialogType != 1"
              >
                <el-option label="公众号文章" value="1"></el-option>
                <el-option label="视频教程" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="form.type == 1"
              label="文章连接"
              :label-width="dialogWidth"
              prop="officialAccountLink"
            >
              <el-input
                v-model="form.officialAccountLink"
                autocomplete="off" :disabled="dialogType == 3"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="form.type == 2"
              label="视频教程"
              :label-width="dialogWidth"
              prop="name"
            >
              <el-upload
                class="avatar-uploader"
                :action="baseURL+'/api/common/file/upload/file'"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="handleVideoSuccess"
                :before-upload="beforeVideoUpload"
                accept=".mp4,.avi,.wmv,.3gp"
                :disabled="dialogType == 3"
              >
                <video controls v-if="form.videoLinkTemp" :src="form.videoLinkTemp" class="avatar" muted autoplay/>
                <i v-else-if="uploadFileVideo == 0" class="el-icon-plus avatar-uploader-icon"></i>
                <i v-else class="el-icon-loading avatar-uploader-icon-loading"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              v-if="form.type == 2"
              label="文字内容"
              :label-width="dialogWidth"
              prop="textContent"
            >
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                :disabled="dialogType == 3"
                 v-model="form.textContent" max="200">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addSubmit('addForm')"
            class="btn"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 名称
      title: "课程详情",
      categoriesInfo: null,
      uploadHeader: {
        authorization: null,
      },
      baseURL:"/",
      // 弹出框显示
      dialogVisible: false,
      dialogWidth: "90px",
      // 弹出窗类型：1 添加
      dialogType: 1,
      // 添加成员的数据
      uploadFileImage: 0,
      uploadFileVideo: 0,
      form: {
        id: null,
        categoriesId: null,
        name: null,
        type: null,
        sortNo: null,
        coverImage: null,
        coverImageTemp: null,
        officialAccountLink: null,
        videoLink: null,
        videoLinkTemp: null,
        textContent: null,
        disabledStatus: null,
      },
      // 校验规则
      rules: {
        userPhone: [
          {
            required: true,
            message: "请输入绑定用户的手机号码",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "手机号码为11位",
            trigger: "blur",
          },
        ],
      },
      search:{
        content: null,
        disabledStatus: null,
        type: null
      },
      page: {
        currPage: 1,
        size: 10,
        total: 1,
      },
      tableData: [],
      // return 结束
    };
  },
  updated() {},
  created() {

    this.baseURL = this.$axios.defaults.baseURL;
    // 加载数据
    let edit = JSON.parse(sessionStorage.getItem("dataInfo"));
    if (edit) {
      if (edit.type != "tutorialCategories") {
        window.history.back();
        return;
      }
      this.categoriesInfo = edit.data;
      this.title = edit.data.name;
      this.uploadHeader.authorization = localStorage.getItem("authorization");

      this.query();
    } else {
      // 没有查询数据，返回上一页
      console.log("没有查询数据，返回上一页");
      window.history.back();
    }
  },
  methods: {
    // 点击了状态
    clickStatus(row) {
      var that = this;
      this.$confirm(
        (row.disabledStatus == 1 ? "禁用" : "启用") +
          "课程【" +
          row.name +
          "】, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        var data = {
          id: row.id,
          name: row.name,
          disabledStatus: row.disabledStatus == 1 ? 0 : 1,
        };
        // 逻辑处理
        that.postJson(
          "/api/web/tutorial/detail/updateDisabledStatus",
          data
        );
      });
    },
    // 点击删除
    clickDelete(row) {
      var that = this;
      this.$confirm("删除课程【" + row.name + "】, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var data = {
          id: row.id,
          name: row.name,
        };
        // 逻辑处理
        that.postJson(
          "/api/web/tutorial/detail/deleteTutorialDetail",
          data
        );
      });
    },
    // 点击了添加
    clickAdd() {
      this.dialogType = 1;
      // 初始化添加成员数据
      this.form = {
        id: null,
        categoriesId: null,
        name: null,
        type: null,
        sortNo: null,
        coverImage: null,
        coverImageTemp: null,
        officialAccountLink: null,
        videoLink: null,
        videoLinkTemp: null,
        textContent: null,
        disabledStatus: null,
      };
      // 显示
      this.dialogVisible = true;
    },
    // 点击了编辑
    clickUpdate(row) {
      this.dialogType = 2;
      // 初始化添加成员数据
      this.form = {
        id: row.id,
        categoriesId: row.categoriesId,
        name: row.name,
        type: row.type,
        sortNo: row.sortNo,
        coverImage: row.coverImage,
        coverImageTemp: row.coverImageTemp,
        officialAccountLink: row.officialAccountLink,
        videoLink: row.videoLink,
        videoLinkTemp: row.videoLinkTemp,
        textContent: row.textContent,
        disabledStatus: row.disabledStatus,
      };
      // 显示
      this.dialogVisible = true;
    },
    clickInfo(row){
      this.dialogType = 3;
      // 初始化添加成员数据
      this.form = {
        id: row.id,
        categoriesId: row.categoriesId,
        name: row.name,
        type: row.type,
        sortNo: row.sortNo,
        coverImage: row.coverImage,
        coverImageTemp: row.coverImageTemp,
        officialAccountLink: row.officialAccountLink,
        videoLink: row.videoLink,
        videoLinkTemp: row.videoLinkTemp,
        textContent: row.textContent,
        disabledStatus: row.disabledStatus,
      };
      // 显示
      this.dialogVisible = true;
    },
    // 提交
    addSubmit(ref) {
      var that = this;
      if(this.uploadFileImage == 1){
        that.$message.info("封面图片上传中，请稍等！");
        return
      }
      if(this.uploadFileVideo == 1){
        that.$message.info("视频上传中，请稍等！");
        return
      }
      // 表单校验
      this.$refs[ref].validate((valid) => {
        // 校验结果
        if (!valid) {
          // 校验不通过
          return;
        }

        var url = "/api/web/tutorial/detail/updateTutorialDetail";
        if (that.dialogType == 1) {
          url = "/api/web/tutorial/detail/addTutorialDetail";
          that.form.id = null;
        }
        that.form.categoriesId = that.categoriesInfo.id;
        // 逻辑处理
        that.postJson(url,that.form)
      });
    },
    postJson(url,data){
      var that = this;
      // 逻辑处理
      that.$axios
        .post(url, data)
        .then((res) => {
          if (res.data.code == 1000) {
            that.$message.success("操作成功");
            that.page.currPage = 1;
            that.dialogVisible = false;
            that.query();
          } else if (res.data.code == 4030) {
            that.table_data = [];
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.info(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击了取消
    clickCancel() {
      sessionStorage.setItem("dataInfo", null);
      this.$router.push({ path: "/tutorial" });
    },
    // 封面上传成功
    handleAvatarSuccess(res, file) {
      console.log(res);
      if(res.code == 1000){
        this.form.coverImageTemp = URL.createObjectURL(file.raw);
        this.form.coverImage = res.data
      }else{
        this.$message.error('上传封面图片失败：'+res.message);
      }
      this.uploadFileImage = 0;
    },
    // 封面上传前置处理
    beforeAvatarUpload(file) {
      console.log(file.type)
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
      const isLM = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('上传封面图片只能是 JPG/PNG/GIF 格式!');
      }
      if (!isLM) {
        this.$message.error('上传封面图片大小不能超过 5MB!');
      }
      if(isImage && isLM){
        this.uploadFileImage = 1;
      }
      return isImage && isLM;
    },
    // 视频上传成功
    handleVideoSuccess(res, file) {
      if(res.code == 1000){
        this.form.videoLinkTemp = URL.createObjectURL(file.raw);
        this.form.videoLink = res.data
      }else{
        this.$message.error('上传视频失败：'+res.message);
      }
      this.uploadFileVideo = 0;
    },
    // 视频上传前置处理
    beforeVideoUpload(file) {
      console.log(file.type)
      const isVideo = file.type === 'video/mp4' || file.type === 'video/avi' || file.type === 'video/wmv' || file.type === 'video/3gp';
      const isLt2M = file.size / 1024 / 1024 < 30;

      if (!isVideo) {
        this.$message.error('上传视频只能是 mp4/avi/wmv/3gp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频大小不能超过 30MB!');
      }
      if(isVideo && isLt2M){
        this.uploadFileVideo = 1;
      }
      return isVideo && isLt2M;
    },
    // 点击分页
    pageChange(res) {
      this.page.currPage = res;
      this.query();
    },
    // 查询数据
    query() {
      let that = this;
      const url = "/api/web/tutorial/detail/queryTutorialDetail";
      this.$axios
        .post(url, {
          page: this.page.currPage,
          size: this.page.size,
          param: {
            categoriesId: this.categoriesInfo.id,
            disabledStatus: this.search.disabledStatus,
            name: this.search.content,
            type: this.search.type
          },
        })
        .then((res) => {
          if (res.data.code == 1000) {
            res.data.data.list.forEach(item => {
              item.coverImageTemp = that.baseURL+item.coverImage;
              item.videoLinkTemp = that.baseURL+item.videoLink;
            });
            that.tableData = res.data.data.list;
            that.page.total = Number(res.data.data.totalItems);
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          that.tableData = [];
        });
    },
    // methods 结束
  },
};
</script>

<style scoped>
/* 外盒子 */
.management-agent-box {
  height: 100%;
  width: 100%;
  padding: 15px;
  background: #f8fafb;
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
/* 内容盒子 */
.content_title {
  width: 100%;
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  /*padding-top: 10px;*/
  border-radius: 5px;
}

/* 内容盒子 
.content {
  width: 100%;
  height: calc(100% - 90px);
 
  background: #ffffff;
  padding-left: 30px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}*/
.content_auto {
  /*height: 100%;*/
  height: calc(100% - 110px);
  overflow-y: auto;
}
/* 内容 */
.content {
  background-color: #fff;
  margin-top: 15px;
  /*margin-left: 15px;*/
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 5px;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}
/* 搜索栏 */
.data_screen {
  height: 90px;
  /*margin-bottom: 15px;
  padding-top: 0px;*/

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;

  display: flex;
  justify-content: start;
  align-items: flex-start;
}
/* 标题 */
.title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
  cursor: pointer;
  /* text-align: center; */
}
/* 用户基本信息 */
.content_user {
  padding-top: 25px;
  height: 180px;
}
/* 头像 */
.pic {
  width: 130px;
  height: 130px;
  overflow: hidden;
  float: left;
}
.pic div {
  width: 130px;
  height: 130px;
}
.userInfo {
  float: left;
  margin-left: 30px;
}
.table_data {
  padding-bottom: 70px;
}
.table_data_left {
  margin-right: 15px;
}
/* 分页 */
.page {
  /* position:absolute;
  bottom: 50px;
  right: 50px; */
  float: right;
  margin-top: 20px;
  margin-right: 20px;
}

.archiveDiv {
  width: 100%;
  margin-top: 10px;
}
.archiveName {
  text-indent: 30px;
}
.archiveView {
  border: 1px solid #aaa7a7;
  margin: 10px 20px;
  border-radius: 10px;
  padding: 10px;
  height: 182px;
}
/* 添加按钮 */
.btn_add {
  position: absolute;
  right: 40px;
}
/* 查询按钮 */
.search_btn{
  margin-left: 20px;
}
.dialog_context {
  width: 500px;
}
.el-form-item__content .avatar-uploader .el-upload--text {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-form-item__content .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.el-form-item__content .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;

  border: 1px dashed #d9d9d9;
}
.el-form-item__content .avatar-uploader-icon-loading {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.el-form-item__content .avatar {
  width: auto;
  height: 178px;
  display: block;
  border: 1px dashed #d9d9d9;
}
.tableImage{
  width: auto; 
  height: 80px;
  border: 1px dashed #d9d9d9;
}
.data_screen .data_screen_tab {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/tutorial/tutorialList.vue